import { cleanFilters } from "@/helpers/cleanFilters";
import { api } from "@/services/api";
import { ApiSelect } from "@/types/apiSelect";
import { useCallback } from "react";

export type ApiSelectOptions = {
  filters?: object;
  /**
   * true → path unchanged (es. "clienti/select") — usato da DataLoader.
   * false → aggiunge "/select" (es. "agenti" → "agenti/select") — usato nei form.
   */
  realPath?: boolean;
};

function resolveSelectPath(path: string, realPath?: boolean): string {
  return realPath === true ? path : `${path}/select`;
}

export async function fetchApiSelect(
  path: string,
  options?: ApiSelectOptions,
): Promise<ApiSelect[]> {
  const response = await api.get<ApiSelect[]>(
    resolveSelectPath(path, options?.realPath),
    { params: cleanFilters(options?.filters ?? {}) },
  );
  return response.data;
}

export async function fetchApiSelectExtended<T>(
  path: string,
  options?: Pick<ApiSelectOptions, "filters">,
): Promise<T[]> {
  const response = await api.get<T[]>(path, {
    params: cleanFilters(options?.filters ?? {}),
  });
  return response.data;
}

export const useApiSelect = () => {
  const apiSelect = useCallback(
    (path: string, options?: ApiSelectOptions): Promise<ApiSelect[]> =>
      fetchApiSelect(path, options),
    [],
  );

  const apiSelectExtended = useCallback(
    <T>(path: string, options?: Pick<ApiSelectOptions, "filters">): Promise<T[]> =>
      fetchApiSelectExtended<T>(path, options),
    [],
  );

  return { apiSelect, apiSelectExtended };
};
